import {type CachesIndexPayload, CachesIndexPayloadSchema} from '@github-ui/dotcom-schema/types/actions/v1/caches_index'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {repoAppBuilder} from '@github-ui/repo-app-builder'

export function buildActionsCachesRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('actionsCachesRoute', {
    path: '/:owner/:repo/actions/caches',
    queries: [mainQuery<CachesIndexPayload>({schema: CachesIndexPayloadSchema})],
  })
}

export const actionsCachesRoute = buildActionsCachesRoute(repoAppBuilder)
